var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-down page"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('wrong_browser.title')))]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('wrong_browser.text'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }